import { assureurService } from "./assureur.services";


class AssureurController {
    constructor(services) {
        this.service = services
    }

    async getListAssureur() {
        let response;
        try {
            response = await this.service.listAssureurServices()
        } catch (error) {
            throw Error("Impossible de charger la liste des assureurs", error)
        }

        return response.data.partenaires;
    }
}

export const partner = new AssureurController(assureurService);